import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import './ErrorPage.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBug } from '@fortawesome/pro-solid-svg-icons';
import ShowHideButton from '../ShowHideButton';
import { FallbackProps } from 'react-error-boundary';
import { isOnPremise } from '../../tracking/environment';

export const ErrorPage = ({ error }: FallbackProps) => {
  return (
    <Container fluid className='error-page'>
      <FontAwesomeIcon icon={faBug} className='bug-icon' />
      <span className='title-l m-t-24'>A bug!</span>
      <span className='text-m m-t-24'>
        There seems to be an error when loading this page. Don’t worry, Salv engineers have already been notified and
        are working to solve the issue.
      </span>
      <span className='title-s mt-6'>What should I do?</span>
      <span className='text-m m-t-16'>
        Try refreshing the page. If the error persists and you need help fast, please contact Salv.
      </span>
      {isOnPremise() && <ErrorPageStacktrace error={error} />}
    </Container>
  );
};

const ErrorPageStacktrace = ({ error }: { error: unknown }) => {
  const [opened, setOpened] = useState(false);

  return (
    <>
      <span className='mt-6' onClick={() => setOpened(!opened)}>
        <ShowHideButton expanded={opened} showText='Show logs' hideText='Hide logs' />
      </span>
      {opened && error && <div className='code-block code-s'>{error.toString()}</div>}
    </>
  );
};

export default ErrorPage;
